import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})
export class ImageSliderComponent implements OnInit {

  @Input() activeSideMenu: any;
  @Input() gisMapComp: any;
  @ViewChild('imageGrid', { static: false }) imageGrid!: ElementRef;
  @ViewChild('imageModal', { static: false }) imageModal!: TemplateRef<any>;

  imageList: string[] = [
    'assets/imgs/flood.jpeg',
    'assets/imgs/crop-loss.jpg',
    'assets/imgs/flood1.jpeg',
    'assets/imgs/crop-loss1.jpeg',
    'assets/imgs/flood.jpeg',
    'assets/imgs/crop-loss.jpg',
    'assets/imgs/flood1.jpeg',
    'assets/imgs/crop-loss1.jpeg',
    'assets/imgs/crop-loss.jpg',
    'assets/imgs/cloud_top_temperature.png',
    'assets/imgs/satellite.jpg'
  ];

  selectedImage: string = '';

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  scrollLeft() {
    this.imageGrid.nativeElement.scrollBy({
      left: -200,  // adjust scroll distance
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.imageGrid.nativeElement.scrollBy({
      left: 200,   // adjust scroll distance
      behavior: 'smooth'
    });
  }

  closePanel() {
    this.gisMapComp.isImageSliderOpen = false
  }

  openModal(image: string) {
    this.selectedImage = image;
    this.modalService.open(this.imageModal, { size: 'lg', centered: true });
  }


}
